import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStoreManager } from './local-store-manager.service';
import { CalendarRule } from '../models/calendarrule.model';

@Injectable()
export class CalendarRuleService {
  private calendarruleUrl: string = 'api/calendarrules';
  private calendarrulerelationUrl: string = 'api/calendarrulerelations';

  constructor(
    private http: HttpClient,
    private localStorage: LocalStoreManager) { }

  getcalendarrules(): Observable<CalendarRule[]> {
    let sitename = this.localStorage.getDataObject("sitename");
    let endpointUrl = `${this.calendarruleUrl}/${sitename}`;
    return this.http.get<CalendarRule[]>(endpointUrl);
  }

  getcalendarrulerelations(query: string): Observable<CalendarRule[]> {
    let endpointUrl = `${this.calendarrulerelationUrl}/${query}`;
    return this.http.get<CalendarRule[]>(endpointUrl);
  }

  updateCalendarRule(calendarrule): Observable<CalendarRule> {
    return this.http.put<CalendarRule>(this.calendarruleUrl, calendarrule);
  }

  newCalendarRule(calendarrule): Observable<CalendarRule> {
    return this.http.post<CalendarRule>(this.calendarruleUrl, calendarrule);
  }

  deleteCalendarRule(id: number) {
    let endpointUrl = `${this.calendarruleUrl}/${id}`;
    return this.http.delete<CalendarRule>(endpointUrl);
  }

}

